<script setup lang="ts">
import { useUserStore } from '@/stores/userStore'

const { userHasRole } = useUserStore()
const eventStore = useEventStore()
const { event } = storeToRefs(eventStore)
const router = useRouter()
const route = useRoute()
const { t } = useI18n()
const breadcrumbs = ref(null)
const isCompanyAdmin = userHasRole('company_administrator')

function getBreadcrumbs() {
  return router.currentRoute.value.matched.map(r => {
    let path = r.path.replace(':id', route.params.id)
    path = path.replace(':event_id', route.params.event_id)
    let name = r.name.replace(':event_id', event.value?.name ?? '')

    return {
      active: path === router.currentRoute.value.fullPath,
      name: name === ':id' ? route.params.id : name,
      path: `${router.options.history.base}${path}`
    }
  })
}

router.afterEach(() => {
  breadcrumbs.value = getBreadcrumbs()
  if (isCompanyAdmin) {
    breadcrumbs.value.splice(0, breadcrumbs.value.length - 2)
  }
})

onMounted(() => {
  breadcrumbs.value = getBreadcrumbs()
  if (isCompanyAdmin) {
    breadcrumbs.value.splice(0, breadcrumbs.value.length - 2)
  }
})

const appbarEventsStore = useAppbarEventStore()
const { buttons, eventFired, showButtons } = storeToRefs(appbarEventsStore)
</script>

<template>
  <div class="d-flex justify-content-between align-items-center w-100 mt-0" style="padding-bottom: 8px">
    <CBreadcrumb class="d-none d-md-flex me-auto mb-0" style="flex: 1 1">
      <li v-for="item in breadcrumbs" :key="item" class="breadcrumb-item active">
        <router-link :to="item.active ? '' : item.path" v-if="!item.active">{{ t(item.name) }}</router-link>
        <span v-else-if="item.active">{{ t(item.name) }}</span>
      </li>
    </CBreadcrumb>

    <div v-if="buttons.length > 0 && showButtons" class="d-flex">
      <div v-for="(button, index) in buttons" :key="index" class="me-3">
        <CLoadingButton
          :color="button.color"
          @click="
            button.event === 'cancel' ? appbarEventsStore.cancelChanges() : appbarEventsStore.$event(button.event)
          "
          :loading="eventFired === button.event"
          :disabled="Boolean(eventFired)"
          size="sm"
        >
          {{ t(button.label) }}
        </CLoadingButton>
      </div>
    </div>
  </div>
</template>
